import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { Comment as CommentType } from '@utils/backend-api/comments';

import IconStar from '../../Images/Rebranding/IconStar';
import TimeAgo from '../../TimeAgo';
import { DELETED_COMMENT_PLACEHOLDER, DELETED_STATE } from '../constants';
import CommentHeader from './Header';

export default function CommentContent({ comment }: { comment: CommentType }) {
  const { user, is_anonymous } = comment;
  const isDeleted = comment.state === DELETED_STATE;

  return (
    <>
      <CommentHeader user={user} isAnonymous={is_anonymous} />
      <div className="ml-0 sm:ml-72">
        {isDeleted ? (
          <div className="font-suisse-intl text-button-md italic text-grayscale-gray">
            {DELETED_COMMENT_PLACEHOLDER}
          </div>
        ) : (
          <>
            {comment.promoted && (
              <div className="group relative mb-4 inline-block cursor-pointer items-center text-primary-magenta hover:text-primary-pink">
                <IconStar className="mr-8 h-16 w-16 align-middle" />
                <span className="font-suisse-screen text-byline-sm">promoted</span>
                <p className="absolute m-0 hidden w-[180px] bg-grayscale-charcoal p-12 font-suisse-intl text-body-sm font-light text-white group-hover:block">
                  Our staff has promoted this comment because it is great!
                </p>
              </div>
            )}
            <div className="font-suisse-intl text-button-md text-primary-black">
              {ReactHtmlParser(comment.body)}
            </div>
          </>
        )}
      </div>

      {isDeleted && (
        <div className="ml-0 mt-32 border-0 border-b border-solid border-grayscale-gray pb-8 sm:ml-72" />
      )}

      {!isDeleted && !!comment.edited_at && (
        <div className="ml-0 text-disclosure-sm text-grayscale-gray sm:ml-72">
          Edited <TimeAgo date={comment.edited_at} timeFromNow />
        </div>
      )}
    </>
  );
}
